import React from 'react';
import './styles.css';

export default class EmailBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstInteraction : true,
    }
    
    this.handleFocus = this.handleFocus.bind(this);
  }
  
  static verify(email) {
    let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return regex.test(email);
  }
  
  handleFocus(event) {
    if (this.state.firstInteraction) {
      this.setState({firstInteraction : false});
      this.props.changeHandler({
        target: {
          value: ""
        }
      });
    }
  }
  
  render() {
    return(
      <div>
        <label htmlFor="email">Please verify your email: </label>
        <input className={this.props.error ? "error" : ""} type="text" id="email" name="email" value={this.props.value} onChange={this.props.changeHandler} onFocus={this.handleFocus}/>
        <input className={this.props.streamlinedUnsub ? "submit unsubscribe" : "submit"} readOnly type="submit" name="submit" value={this.props.streamlinedUnsub ? "Unsubscribe" : "Submit"}/>
      </div>
    );
  }
}